import createCachedSelector from "re-reselect";

import { getLegByDirection } from "@app/helpers/udm";
import { getTripsSegments } from "@app/modules/results/selectors/state-accessors";
import { getTripById } from "@app/modules/results/selectors/trips/get-trip";

export const getSegmentsPerDirection = createCachedSelector(
  [getTripById, getTripsSegments, (_state, _trip_id, direction) => direction],
  (trip, trips_segments, direction: "outbound" | "return") => {
    // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    const segment_ids = getLegByDirection(trip, direction).segment_ids;
    return segment_ids.map(segment_id => trips_segments[segment_id]);
  }
)((_state, trip_id, direction: string) => `${trip_id}:${direction}`);
